// images = publicConfig.images from master API response
// Accepts: { banner, logo, pic1, pic2, ... }  or  { banner, logo, atmosphere: [...] }

export function loadBannerImage(images = {}) {
    return images?.banner || '/images/default/banner.webp'
}

export function loadLogoImage(images = {}) {
    return images?.logo || null
}

export function loadAtmosphereImages(images = {}) {
    // Format A: atmosphere array
    if (Array.isArray(images?.atmosphere) && images.atmosphere.length > 0) {
        return images.atmosphere
    }

    // Format B: individual pic1, pic2, ... keys
    const result = []
    for (let i = 1; i <= 20; i++) {
        const url = images?.[`pic${i}`]
        if (url) result.push(url)
        else break
    }
    return result
}
